import React from 'react';

/**
 * Infinite horizontal scroller. Duplicates its children twice so the second
 * copy can seamlessly follow the first as the animation loops.
 *
 * Props:
 *   speed       — seconds per full loop (default 30)
 *   direction   — 'left' | 'right'
 *   pauseOnHover
 *   fadeEdges   — mask soft fade on left/right edges
 */
const STYLE_ID = 'esg-marquee-style';
const ensureStyle = () => {
  if (typeof document === 'undefined') return;
  if (document.getElementById(STYLE_ID)) return;
  const s = document.createElement('style');
  s.id = STYLE_ID;
  s.textContent = `
    @keyframes esg-marquee-left {
      from { transform: translateX(0); }
      to   { transform: translateX(-50%); }
    }
    @keyframes esg-marquee-right {
      from { transform: translateX(-50%); }
      to   { transform: translateX(0); }
    }
    .esg-marquee-track { display: inline-flex; gap: 2.5rem; padding-right: 2.5rem; will-change: transform; }
    .esg-marquee-hover:hover .esg-marquee-track { animation-play-state: paused; }
    @media (prefers-reduced-motion: reduce) {
      .esg-marquee-track { animation: none !important; transform: none !important; }
    }
  `;
  document.head.appendChild(s);
};

const Marquee = ({
  children,
  speed = 30,
  direction = 'left',
  pauseOnHover = true,
  fadeEdges = true,
  className = '',
}) => {
  ensureStyle();
  const animation = `esg-marquee-${direction} ${speed}s linear infinite`;
  const items = React.Children.toArray(children);

  return (
    <div
      className={`overflow-hidden ${pauseOnHover ? 'esg-marquee-hover' : ''} ${className}`}
      style={
        fadeEdges
          ? {
              maskImage:
                'linear-gradient(90deg, transparent 0%, black 8%, black 92%, transparent 100%)',
              WebkitMaskImage:
                'linear-gradient(90deg, transparent 0%, black 8%, black 92%, transparent 100%)',
            }
          : {}
      }
    >
      <div className="whitespace-nowrap" style={{ display: 'inline-block', width: 'max-content' }}>
        <div className="esg-marquee-track" style={{ animation }}>
          {items.map((child, i) => (
            <div key={`a-${i}`} className="inline-flex items-center shrink-0">
              {child}
            </div>
          ))}
          {items.map((child, i) => (
            <div key={`b-${i}`} className="inline-flex items-center shrink-0" aria-hidden="true">
              {child}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Marquee;
